import { axiosInstance } from "./axiosInstance";

export const AdminService = {
	getAll: async (filter) => {
		return await axiosInstance.get("/api/feature/super-admin/admin", {
			params: filter,
		});
	},
	getDetail: async (filter) => {
		return await axiosInstance.get("/api/feature/super-admin/admin", {
			params: filter,
		});
	},
	setPermission: async (id, data) => {
		return await axiosInstance.post(`/api/feature/super-admin/permission/attach-detach/${id}`, data);
	},
	changePassword: async (data) => {
		return await axiosInstance.post("/api/auth/admin/change-password", data);
	}
};
